import React, { createContext, ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';
import { CALL_OPTION, selectors } from 'state';
import { OptionsChainRow } from './OptionsTab/OptionsChain';

type logsContextType = {
  instrumentType: string;
  setInstrumentType: (instrumentType: string) => void;
  showCash: boolean;
  setShowCash: (showCash: boolean) => void;
  geoLeft: string;
  // setGeoLeft: (geoLeft: string) => void;
  setGeoLeft: React.Dispatch<React.SetStateAction<string>>;
  geoMid: string;
  setGeoMid: React.Dispatch<React.SetStateAction<string>>;
};

export const TraineeSessionContext = createContext<logsContextType>({
  instrumentType: '',
  // Using an empty function here makes sense, since you provide an empty, default value.
  // Otherwise, you have to check if setSelected is undefined every time you'd want to use it, which is annoying.
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setInstrumentType: () => {},
  showCash: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setShowCash: () => {},
  geoLeft: '',
  // setGeoLeft: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setGeoLeft: (_: React.SetStateAction<string>) => {},
  geoMid: '',
  // setGeoMid: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setGeoMid: (_: React.SetStateAction<string>) => {},
});

export function TraineeSessionContextWrapper(props: {
  children: ReactElement;
}) {
  const [instrumentType, setInstrumentType] = useState<string>('');
  const [showCash, setShowCash] = useState<boolean>(false);
  const [geoLeft, setGeoLeft] = useState<string>('');
  const [geoMid, setGeoMid] = useState<string>('');

  return (
    <TraineeSessionContext.Provider
      value={{
        instrumentType: instrumentType,
        setInstrumentType: setInstrumentType,
        showCash: showCash,
        setShowCash: setShowCash,
        geoLeft: geoLeft,
        setGeoLeft: setGeoLeft,
        geoMid: geoMid,
        setGeoMid: setGeoMid,
      }}
    >
      {props.children}
    </TraineeSessionContext.Provider>
  );
}
